import React from 'react';
import { useSelector } from '../redux-hook-adapters';
import styled from 'styled-components';
import { GameState, GameStatus, RescueResource } from '../../metadata/types';
import { formatTime } from '../../time-format-utils';

const Wrapper = styled.div`
  font-size: 14px;
`;

const Title = styled.h1`
  font-family: Orbitron;
  text-align: center;
`;

const ColumnHalf = styled.div`
  width: calc(50% - 10px);
  display: inline-block;
  padding: 5px;
`;

const DataPoint = styled.div`
  margin-bottom: 10px;
`;

const StatName = styled.div`
  display: inline-block;
  font-weight: bold;
  width: 60%;
  margin-right: 5px;
`;

const StatValue = styled.div`
  display: inline-block;
`;

export default () => {

  const state = useSelector((state: GameState) => state);
  const stats = state.gameStats;

  return <Wrapper>
    <Title>Statistiques de fin de jeu</Title>
    <ColumnHalf>
      <DataPoint>
        <StatName>Retourné sur Sagittaire</StatName>
        <StatValue>
          {
            state.status === GameStatus.MissionSucceeded ?
            `Jour ${state.time}` : 'Vous n’avez pas terminé'
          }
        </StatValue>
      </DataPoint>
      <DataPoint>
        <StatName>Scientifiques sauvés</StatName>
        <StatValue>
          {
            state.status === GameStatus.MissionSucceeded ?
            `${stats.scientistsRemaining} de 20` : 'Aucun'
          }
        </StatValue>
      </DataPoint>
      <DataPoint>
        <StatName>Durée de la mission</StatName>
        <StatValue>
          {
            formatTime(state.endTime! - state.startTime + state.accumulatedTime)
          }
        </StatValue>
      </DataPoint>
      <DataPoint>
        <StatName>Oxygène – temporaire (requis au Jour 6)</StatName>
        <StatValue>
          {
            stats.dropOffTimes[RescueResource.O2ReplacementCells] > -1 ?
            `Livré au Jour ${stats.dropOffTimes[RescueResource.O2ReplacementCells]}` : 'Aucune restauration ou réparation'
          }
        </StatValue>
      </DataPoint>
    </ColumnHalf>
    <ColumnHalf>
      <DataPoint>
        <StatName>Oxygène (requis au Jour 21)</StatName>
        <StatValue>
          {
            stats.dropOffTimes[RescueResource.OxygenRepairTeam] > -1 ?
            `Livré au Jour ${stats.dropOffTimes[RescueResource.OxygenRepairTeam]}` : 'Aucune restauration ou réparation'
          }
        </StatValue>
      </DataPoint>
      <DataPoint>
        <StatName>Eau (requise au Jour 23)</StatName>
        <StatValue>
          {
            stats.dropOffTimes[RescueResource.WaterRepairTeam] > -1 ?
            `Livré au Jour ${stats.dropOffTimes[RescueResource.WaterRepairTeam]}` : 'Aucune restauration ou réparation'
          }
        </StatValue>
      </DataPoint>
      <DataPoint>
        <StatName>Nourriture (requise au Jour 24)</StatName>
        <StatValue>
          {
            stats.dropOffTimes[RescueResource.FoodRepairTeam] > -1 ?
            `Livré au Jour ${stats.dropOffTimes[RescueResource.FoodRepairTeam]}` : 'Aucune restauration ou réparation'
          }
        </StatValue>
      </DataPoint>
      <DataPoint>
        <StatName>Composantes médicales (requises au Jour 25)</StatName>
        <StatValue>
          {
            stats.dropOffTimes[RescueResource.FoodRepairTeam] > -1 ?
            `Livré au Jour ${stats.dropOffTimes[RescueResource.FoodRepairTeam]}` : 'Aucune restauration ou réparation'
          }
        </StatValue>
      </DataPoint>
    </ColumnHalf>
  </Wrapper>;
}